import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const ArrowDown: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'arrow-down-s-line'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        {...props}>
        <g id={label}>
          <path
            id="Icon"
            d="M12.0002 13.1719L16.9502 8.22192L18.3642 9.63592L12.0002 15.9999L5.63623 9.63592L7.05023 8.22192L12.0002 13.1719Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </AccessibleIcon.Root>
  )
}

export default ArrowDown
